import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const HERO_IMG = "/hero.png";

const spring = { type: "spring", stiffness: 60, damping: 18 };

export const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
    <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-75% via-black/80 to-white" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-40 pb-32 w-full">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ ...spring, delay: 0.1 }}
        className="font-heading text-base md:text-lg font-bold uppercase tracking-[0.35em] text-[#00E5FF] mb-8"
      >
        Harris Holt Consulting
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ ...spring, delay: 0.25 }}
        className="text-5xl sm:text-6xl lg:text-7xl font-heading font-medium tracking-tighter leading-none text-white max-w-4xl"
      >
        Smarter Digital. Forward-Moving Innovation.
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ ...spring, delay: 0.4 }}
        className="mt-8 max-w-2xl text-lg md:text-xl leading-relaxed text-zinc-400"
      >
        An industry and technology leader serving government and commercial
        customers — from AI agents and generative AI to secure, ready-to-deploy
        digital infrastructure.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ ...spring, delay: 0.55 }}
        className="mt-12 flex flex-wrap gap-4"
      >
        <a
          href="#expertise"
          data-testid="hero-explore-button"
          className="inline-flex items-center gap-3 bg-[#00E5FF] text-black font-bold uppercase tracking-wider px-8 py-4 hover:bg-[#33EAFF] transition-colors"
        >
          Explore Expertise <ArrowRight size={18} />
        </a>
        <a
          href="#contact"
          data-testid="hero-contact-button"
          className="inline-flex items-center gap-3 bg-transparent border border-white/20 text-white font-bold uppercase tracking-wider px-8 py-4 hover:bg-white/5 transition-colors"
        >
          Contact Us
        </a>
      </motion.div>
    </div>
  </section>
);
